import React from 'react';
import { Modal } from 'react-materialize';

const PilotlyModal = (props) => (
	<div>
		{props.backgroundCover  &&
			<div className="modal-background-cover"></div>
		}
		<Modal
			id={props.id}
			className={props.className}
			header={props.header}
			actions={props.actions}>
			{props.message}
		</Modal>	
	</div>
);


export default PilotlyModal;


// WEBPACK FOOTER //
// ./src/components/global/PilotlyModal.js